<template>
  <v-dialog persistent v-model="dialog" max-width="590">
    <v-card>
      <v-card-text>
        <v-card class="pt-5">
          <v-toolbar color="cyan" dark flat>
            <v-toolbar-title>Finalizar reserva</v-toolbar-title>
            <template v-slot:extension>
              <v-tabs v-model="checkoutValues.tab" align-with-title>
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab>Valor</v-tab>
                <v-tab>Imagens</v-tab>
              </v-tabs>
            </template>
          </v-toolbar>

          <v-tabs-items v-model="checkoutValues.tab">
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-flex md8>
                    <label for="model"
                      >Valor a ser cobrado pela quilometragem:</label
                    >
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span
                          class="input-group-text font-weight-medium"
                          id="basic-addon1"
                        >
                          R$
                        </span>
                      </div>
                      <money
                        v-bind="money"
                        v-model="checkoutValues.quilometragemValue"
                        class="form-control"
                      >
                      </money>
                    </div>
                  </v-flex>

                  <v-flex md8>
                    <label for="model">Valor da Multa</label>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span
                          class="input-group-text font-weight-medium"
                          id="basic-addon1"
                        >
                          R$
                        </span>
                      </div>
                      <money
                        v-bind="money"
                        v-model="checkoutValues.mulctValue"
                        class="form-control"
                      >
                      </money>
                    </div>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <!--
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-flex md8>
                    <v-text-field
                      v-model="checkoutValues.quilometragemPecorrida"
                      label="Quilometragem percorrida:"
                    ></v-text-field>
                  </v-flex>

                  <v-flex md8>
                    <v-text-field
                      v-model="checkoutValues.atraso"
                      label="Tempo de atraso(Em minutos):"
                    ></v-text-field>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-tab-item>
            -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <h6>Adicionar imagens:</h6>

                  <div
                    v-for="(formField, index) in formFields"
                    :key="index"
                    :value="formField.id"
                  >
                    <v-file-input
                      v-model="image"
                      show-size
                      :label="formField.description"
                      @change="inputChanged(formField.id)"
                    >
                    </v-file-input>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="$emit('disagree')">
          Cancelar
        </v-btn>

        <v-btn color="green darken-1" text @click="finishCheckOut">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialog: Boolean,
    vehicleRequestId: Number,
    vehicleRequestValues: Object,
    formFields: Array,
  },
  watch: {
    vehicleRequestValues() {
      this.checkoutValues.mulctValue = Number.parseFloat(
        (this.vehicleRequestValues.mulctInCents / 100).toFixed(2)
      );
      this.checkoutValues.quilometragemValue = Number.parseFloat(
        (this.vehicleRequestValues.price_by_km / 100).toFixed(2)
      );
      // this.checkoutValues.quilometragemPecorrida = this.vehicleRequestValues.metersTraveled
    },
  },
  data: () => ({
    checkoutValues: {
      tab: null,
      mulctValue: null,
      quilometragemValue: null,
      quilometragemPecorrida: null,
      atraso: null,
      vehicleRequestId: null,
    },
    money: {
      decimal: ',',
      thousands: '.',
      precision: 2,
      masked: true,
    },

    formImages: {},
    image: null,
  }),
  methods: {
    finishCheckOut() {
      this.checkoutValues.vehicleRequestId = this.vehicleRequestId;
      this.$emit('agree', this.checkoutValues, this.formImages);
    },

    inputChanged(formFieldId) {
      this.formImages[formFieldId] = this.image;
      this.image = null;
    },
  },
};
</script>
